const mEditionMenu = {
  mEditionMenu: {
    academy: {
      autoresponders: {
        subject: 'autoresponders',
        text: 'Autoresponders',

        children: {
          connectAutoresponder: {
            goBackText: 'volver a listado',
            subedition: 'asociar-autoresponder',
            text: 'Asociar Autoresponder'
          },

          selectAutoresponder: {
            goBackText: 'volver a listado',
            subedition: 'seleccionar-autoresponder',
            text: 'Seleccionar Autoresponder'
          }
        }
      },

      configuration: {
        subject: 'configuracion',
        text: 'Configuración'
      },

      invitations: {
        subject: 'invitaciones',
        text: 'Envío de Invitaciones'
      },

      legals: {
        subject: 'textos-legales',
        submenu: true,
        text: 'Textos Legales',

        children: {
          emailClause: {
            subedition: 'clausula-correo',
            subText: 'Cláusula Correo'
          },

          emailSignature: {
            subedition: 'firma-de-email',
            subText: 'Firma de Email'
          },

          privacyPolicies: {
            subedition: 'politicas-de-privacidad',
            subText: 'Políticas de Privacidad'
          },

          termsAndConditions: {
            subedition: 'terminos-y-condiciones',
            subText: 'Términos y Condiciones'
          }
        }
      },

      data: {
        subject: 'datos-academia',
        text: 'Datos de Academia'
      },

      users: {
        subject: 'usuarios',
        text: 'Usuarios',

        children: {
          profile: {
            goBackText: 'volver a listado',
            subedition: 'perfil',
            submenu: true,
            text: 'Perfil',

            children: {
              account: {
                goBackText: 'volver a listado',
                subitem: 'datos-personales',
                text: 'Datos Personales'
              },

              assets: {
                goBackText: 'volver a listado',
                subitem: 'cursos',
                text: 'Cursos'
              },

              maps: {
                goBackText: 'volver a listado',
                subitem: 'mapas',
                text: 'Mapas'
              },

              sales: {
                goBackText: 'volver a listado',
                subitem: 'historial-de-pagos',
                text: 'Historial de Pagos'
              },

              salesRecord: {
                goBackText: 'volver a listado',
                subitem: 'detalle-de-venta',
                text: 'Detalle de Venta'
              }
            }
          }
        }
      }
    },

    account: {
      notifications: {
        subject: 'notificaciones',
        text: 'Notificaciones',

        children: {
          configuration: {
            goBackText: 'volver a listado',
            subedition: 'configuracion',
            text: 'Configuración'
          }
        }
      },

      profile: {
        subject: 'perfil',
        text: 'Datos de Perfil'
      },

      security: {
        subject: 'seguridad',
        text: 'Seguridad'
      }
    },

    asset: {
      activation: {
        subject: 'activacion',
        submenu: true,
        text: 'Activación',

        children: {
          activate: {
            subedition: 'activacion',
            subText: 'Activación'
          },

          sendingOfDeliverables: {
            subedition: 'entregables',
            subText: 'Entregables'
          },

          create: {
            goBackText: 'volver a listado',
            subedition: 'crear-entregable',
            text: 'Crear Entregable'
          },

          edit: {
            goBackText: 'volver a listado',
            subedition: 'editar-entregable',
            text: 'Editar Entregable'
          }
        }
      },

      card: {
        subject: 'tarjeta',
        text: 'Tarjeta'
      },

      comments: {
        subject: 'comentarios',
        text: 'Mensajes',

        children: {
          reports: {
            goBackText: 'volver a comentarios',
            subedition: 'reportes',
            text: 'Reportes'
          }
        }
      },

      contents: {
        subject: 'contenidos',
        text: 'Contenidos',

        children: {
          editor: {
            goBackText: 'volver a listado',
            subedition: 'editor',
            text: 'Editar Contenido'
          }
        }
      },

      delete: {
        subject: 'eliminar',
        text: 'Eliminar Curso'
      },

      duplicate: {
        subject: 'duplicar',
        text: 'Duplicar Curso'
      },

      invitations: {
        subject: 'invitaciones',
        text: 'Invitaciones'
      },

      signedStudents: {
        subject: 'alumnos',
        submenu: true,
        text: 'Alumnos',

        children: {
          contents: {
            goBackText: 'volver a listado',
            subedition: 'contenidos',
            text: 'Contenidos Activos'
          },

          invitations: {
            subedition: 'invitaciones',
            subText: 'Invitaciones'
          },

          profile: {
            goBackText: 'volver a listado',
            subedition: 'perfil',
            text: 'Perfil de Usuario'
          },

          statics: {
            subedition: 'estadisticas',
            subText: 'Estadísticas'
          },

          students: {
            subedition: 'alumnos',
            subText: 'Alumnos'
          }
        }
      }
    },

    billing: {
      customizedPlan: {
        subject: 'plan-personalizado',
        text: 'Cambio de Plan Personalizado',

        children: {
          change: {
            goBackText: '',
            subedition: 'cambiar',
            text: 'cambiar plan'
          }
        }
      },

      myCharges: {
        subject: 'mis-cobros',
        text: 'Mis Cobros',

        children: {
          invoice: {
            goBackText: 'volver a listado',
            subedition: 'comprobante',
            text: 'Comprobante'
          }
        }
      },

      myPayments: {
        subject: 'pagos-vidroop',
        submenu: true,
        text: 'Pagos a Vidroop',

        children: {
          cancelSubscription: {
            goBackText: '',
            subedition: 'cancelar-suscripcion',
            subText: 'Cancelar Suscripción'
          },

          changePlan: {
            goBackText: '',
            subedition: 'cambiar-plan'
          },

          changePlanCustomized: {
            goBackText: '',
            subedition: 'cambiar-plan-personalizado'
          },

          invoice: {
            goBackText: 'volver a listado',
            subedition: 'comprobante',
            text: 'Comprobante'
          },

          invoiceHistory: {
            goBackText: '',
            subedition: 'historial-de-facturas',
            subText: 'Historial de Facturas'
          },

          paymentMethod: {
            goBackText: '',
            subedition: 'medio-de-pago',
            subText: 'Medio de Pago'
          },

          billingData: {
            goBackText: '',
            subedition: 'mis-datos-de-facturacion',
            subText: 'Mis Datos de Facturacion'
          },

          subscribedPlan: {
            goBackText: '',
            subedition: 'plan-suscrito',
            subText: 'Plan Suscrito'
          }
        }
      },

      mySales: {
        subject: 'mis-ventas',
        text: 'Mis Ventas',

        children: {
          invoice: {
            goBackText: 'volver atrás',
            subedition: 'comprobante',
            text: 'Comprobante'
          },

          invoicesHistory: {
            goBackText: 'volver atrás',
            subedition: 'historial-de-comprobantes',
            text: 'Historial de Comprobantes'
          },

          record: {
            goBackText: 'volver a listado',
            subedition: 'registro',
            text: 'Detalle de Venta'
          }
        }
      },

      paymentMethods: {
        subject: 'medios-de-pago',
        text: 'Medios de Pago',

        children: {
          connectMethod: {
            goBackText: 'volver a listado',
            subedition: 'conectar-medio',
            text: 'Conectar Medio de Pago'
          },

          editMethod: {
            goBackText: 'volver a listado',
            subedition: 'editar-medio',
            text: 'Editar Medio de Pago'
          },

          selectMethod: {
            goBackText: 'volver a listado',
            subedition: 'seleccionar-medio',
            text: 'Seleccionar Medio de Pago'
          }
        }
      },

      salesData: {
        subject: 'puntos-de-venta',
        text: 'Puntos de Venta',

        children: {
          createData: {
            goBackText: 'volver a listado',
            subedition: 'crear-punto',
            text: 'Crear Punto de Venta'
          },

          editData: {
            goBackText: 'volver a listado',
            subedition: 'editar-punto',
            text: 'Editar Punto de Venta'
          }
        }
      },

      salesReports: {
        subject: 'informes-de-ventas',
        text: 'Informes de Venta'
      },

      fiscalAuthorizer: {
        subject: 'autorizador-fiscal',
        text: 'Autorizador Fiscal',

        children: {
          connectAuthorizer: {
            subedition: 'conectar-autorizador',
            text: 'Conectar Autorizador Fiscal'
          },

          editAuthorizer: {
            subedition: 'editar-autorizador',
            text: 'Editar Autorizador Fiscal'
          },

          selectAuthorizer: {
            goBackText: 'volver a listado',
            subedition: 'seleccionar-autorizador',
            text: 'Seleccionar Autorizador Fiscal'
          }
        }
      }
    },

    map: {
      activation: {
        subject: 'activacion',
        submenu: true,
        text: 'Activación',

        children: {
          days: {
            goBackText: '',
            subedition: 'dias',
            subText: 'Activación'
          },

          sendingOfDeliverables: {
            goBackText: '',
            subedition: 'entregables',
            subText: 'Entregables'
          },

          sendingOfDeliverablesCreate: {
            goBackText: 'volver a listado',
            subedition: 'crear-entregable',
            text: 'Crear Entregable'
          },

          sendingOfDeliverablesEdit: {
            goBackText: 'volver a listado',
            subedition: 'editar-entregable',
            text: 'Editar Entregable'
          }
        }
      },

      card: {
        subject: 'tarjeta',
        text: 'Tarjeta'
      },

      chart: {
        subject: 'mapa',
        text: 'Mapa'
      },

      enrollments: {
        subject: 'alumnos',
        submenu: true,
        text: 'Alumnos',

        children: {
          contents: {
            goBackText: 'volver a listado',
            subedition: 'contenidos',
            text: 'Contenidos Activos'
          },

          families: {
            goBackText: '',
            subedition: 'equipos',
            subText: 'Equipos'
          },

          familyMembers: {
            goBackText: 'volver atrás',
            subedition: 'equipo-integrantes',
            subText: 'Integrantes de Equipo'
          },

          invitations: {
            goBackText: '',
            subedition: 'invitaciones',
            subText: 'Invitaciones'
          },

          statics: {
            subedition: 'estadisticas',
            subText: 'Estadísticas'
          },

          students: {
            goBackText: '',
            subedition: 'alumnos',
            subText: 'Alumnos'
          }
        }
      },

      messages: {
        subject: 'mensajes',
        text: 'Mensajes'
      },

      path: {
        subject: 'camino',
        text: 'Camino'
      },

      tasks: {
        subject: 'tareas',
        text: 'Tareas'
      }
    },

    product: {
      assetsIncluded: {
        subject: 'cursos-y-mapas-incluidos',
        submenu: true,
        text: 'Formaciones Incluidas',

        children: {
          assets: {
            subedition: 'cursos',
            subtext: 'Cursos'
          },

          maps: {
            subedition: 'mapas',
            subtext: 'Mapas'
          }
        }
      },

      satellitesIncluded: {
        subject: 'satelites-incluidos',
        submenu: true,
        text: 'Satélites Incluidos',

        children: {
          juedroop: {
            subedition: 'juedroop',
            subtext: 'Juedroop'
          },

          evaluacion: {
            subedition: 'evaluaciones',
            subtext: 'Evaluaciones'
          },

          ruleta: {
            subedition: 'ruleta',
            subtext: 'Ruleta'
          }
        }
      },

      artificialIntelligence: {
        subject: 'inteligencia-artificial',
        submenu: true,
        text: 'Inteligencia Artificial',

        children: {
          mensual: {
            subedition: 'mensual',
            subtext: 'Mensual'
          },

          creditos: {
            subedition: 'paquetes-de-creditos',
            subtext: 'Paquetes de Créditos'
          }
        }
      },

      autorespondersLists: {
        subject: 'autoresponders',
        text: 'Autoresponders'
      },

      card: {
        subject: 'tarjeta',
        text: 'Tarjeta del Producto',

        children: {
          types: {
            goBackText: 'volver a tarjeta',
            subedition: 'tipos',
            text: 'Tipos de Tarjetas'
          }
        }
      },

      delete: {
        subject: 'eliminar',
        text: 'Eliminar'
      },

      discountCodes: {
        subject: 'codigos-de-descuento',
        text: 'Códigos de Descuento',

        children: {
          create: {
            goBackText: 'volver a listado',
            subedition: 'crear-codigo-de-descuento',
            text: 'Crear Código de Descuento'
          },

          edit: {
            goBackText: 'volver a listado',
            subedition: 'editar-codigo-de-descuento',
            text: 'Editar Código de Descuento'
          }
        }
      },

      duplicate: {
        subject: 'duplicar',
        text: 'Duplicar'
      },

      pagesOfGratefulness: {
        subject: 'paginas-de-agradecimiento',
        submenu: true,
        text: 'Páginas de Agradecimiento',

        children: {
          externalSite: {
            subedition: 'sitio-externo',
            subText: 'Agregar Carta'
          },

          import: {
            subedition: 'importar-de-otro-producto',
            subText: 'Importar de otro Producto'
          },

          myPages: {
            subedition: 'mis-paginas',
            subText: 'Mis Páginas'
          },

          templates: {
            subedition: 'templates',
            subText: 'Templates'
          }
        }
      },

      prices: {
        subject: 'precios',
        text: 'Precios y Planes',

        children: {
          currency: {
            goBackText: 'volver atrás',
            subedition: 'moneda',
            text: 'Configurar'
          }
        }
      },

      pricesAndPlans: {
        subject: 'precios-y-planes',
        text: 'Precios y Planes'
      },

      pricesAndPlansVidroop: {
        subject: 'precios-y-planes-vidroop',
        text: 'Precios y Planes'
      },

      salesLetters: {
        subject: 'cartas-de-venta',
        submenu: true,
        text: 'Cartas de Venta',

        children: {
          externalSite: {
            subedition: 'sitio-externo',
            subText: 'Agregar Carta'
          },

          import: {
            subedition: 'importar-de-otro-producto',
            subText: 'Importar de otro Producto'
          },

          mySalesLetters: {
            subedition: 'mis-cartas-de-venta',
            subText: 'Mis Cartas de Venta'
          },

          templates: {
            subedition: 'templates',
            subText: 'Templates'
          }
        }
      },

      trackingCodes: {
        subject: 'codigos-de-rastreo',
        text: 'Códigos de Rastreo',

        children: {
          edit: {
            goBackText: 'volver a listado',
            subedition: 'editar-codigo-de-rastreo',
            text: 'Editar Código de Rastreo'
          },

          create: {
            goBackText: 'volver a listado',
            subedition: 'crear-codigo-de-rastreo',
            text: 'Crear Código de Rastreo'
          }
        }
      }
    }
  }
}

export default mEditionMenu
